import React from "react";

import { useTranslation } from "react-i18next";

import SimpleImageUpload from "../utils/SimpleImageUpload";

import type { JSX } from "react";

interface ProfilePictureProps {
  userAvatar?: string;
  setUserAvatar?: (value: string) => void;
  isDisabled?: boolean;
}

function ProfilePicture({
  userAvatar,
  setUserAvatar,
  isDisabled,
}: ProfilePictureProps): JSX.Element {
  const { t } = useTranslation("editor-users");
  return (
    <div className="editor-form-section">
      <div className="editor-form-section-title logo">{t("logo")}</div>
      <SimpleImageUpload
        rounded
        format="1_1"
        id="user-picture"
        isDisabled={isDisabled}
        onFileLoad={setUserAvatar}
        value={userAvatar}
      />
    </div>
  );
}

export default ProfilePicture;
